import React, { useCallback, useContext, useState } from 'react';
import { Input } from 'antd';

import AddressContext from '@totem/components/orgManagement/orgDetails/buildings/options/addressContext';
import { debounce } from '@totem/utilities/debounce';
const { Search } = Input;
const DEBOUNCE_TIME = 500;

const AddressSearchInput = () => {
  const [localSearchTerm, setLocalSearchTerm] = useState<string>('');
  const { setSearchTerm } = useContext(AddressContext);

  const sendChange = useCallback(
    debounce(
      (newSearchTerm: string) => setSearchTerm(newSearchTerm),
      DEBOUNCE_TIME,
    ),
    [],
  );

  const handleSearch = (value: string) => {
    setLocalSearchTerm(value);

    sendChange(value);
  };

  return (
    <Search
      placeholder="input search text"
      value={localSearchTerm}
      onSearch={handleSearch}
      onChange={(evt) => handleSearch(evt.target.value)}
      style={{ width: 400 }}
    />
  );
};

export default AddressSearchInput;
